<template>
  <div class="home">
    <main>
      <h1 id="waveTitle">Discover simply wave</h1>
      <p id="waveSubtitle">
        The simplest way to make your text wave like a pro
      </p>

      <div id="btn-box">
        <router-link to="/playground">Playground</router-link>
        <a target="_blank" href="https://github.com/Meedev-agency/simply_wave"
          >Github</a
        >
      </div>

      <p id="install">
        $ npm install simply_wave
        <i @click="copyToClipboard" class="fa-regular fa-copy"></i>
      </p>
    </main>
  </div>
</template>

<script>
import { wave } from "simply_wave";
export default {
  name: "HomeView",
  methods: {
    copyToClipboard() {
    navigator.clipboard.writeText('npm install simply_wave');
    document.querySelector('#install i').setAttribute("id", "active")
    setTimeout(() => {
        document.querySelector('#install i').removeAttribute("id", "active")
    }, 2000);
}
  },
  mounted() {
    const waveTitleOptions = {
      target: "waveTitle",
      duration: 500,
      animationDelay: 200,
      letterDelay: 40,
      iterations: "1",
      easing: "linear",
      fill: "both",
      direction: "normal",
      opacity: false,
      overflow: true,
    };

    const waveSubitleOptions = {
      target: "waveSubtitle",
      duration: 500,
      animationDelay: 200,
      letterDelay: 20,
      iterations: "1",
      easing: "linear",
      fill: "both",
      direction: "normal",
      opacity: false,
      overflow: true,
    };

    wave(waveTitleOptions);
    wave(waveSubitleOptions);
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/style.scss";

  h1 {
    font-size: 50px;

    & + p {
      margin-top: 2px;
    }
  }

  #btn-box {
    margin-top: 40px;
    display: flex;
    column-gap: 20px;

    a {
      background-color: $blue;
      padding: 10px 15px;
      border-radius: 15px;
      color: white;
      text-decoration: none;
    }
  }

  #install {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    border-radius: 8px;
    margin-top: 40px;
    box-shadow: 0px 2px 10px rgb(222, 222, 222);
    background-color: #f1f1f1;
    color: gray;
    // font-family: "tech";

    i {
      font-size: 20px;
      margin-left: 10px;
      position: relative;
      display: flex;
      align-items: center;

      &:hover {
        cursor: pointer;
      }

      &::after {
        content: "copied !";
        position: absolute;
        right: -400% !important;
        transition: 400ms ease-in-out;
        transform: translateX(-200%);
        opacity: 1;
        z-index: -1;
        font-size: 15px;
        font-weight: 500;
        font-family: Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
      }

      &#active {
        &::after {
          transform: translateX(0%);
          opacity: 1;
        }
      }
    }
  }
</style>